module.exports = __webpack_public_path__ + "img/kategoria_matrymonialne.a85822ad.jpg";